export const STYLE_CARDS = [
  {
    id: "Gouache",
    name: "Gouache",
    description: "Painterly, textured, warm, rich color with visible brushstrokes.",
    image:
      "https://images.unsplash.com/photo-1565510442672-66f367e44609?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxnb3VhY2hlJTIwcGFpbnRpbmclMjBpbGx1c3RyYXRpb258ZW58MHx8fHwxNzgyNDAyMzY4fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "Ink and Flat",
    name: "Ink and Flat",
    description: "Clean lines, bold shapes, graphic, modern.",
    image:
      "https://images.unsplash.com/photo-1549277513-f1b32fe1f8f5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxpbmslMjBhbmQlMjBmbGF0JTIwaWxsdXN0cmF0aW9ufGVufDB8fHx8MTc4MjQwMjM2OHww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "Pencil",
    name: "Pencil",
    description: "Delicate, detailed, intimate, fine line work.",
    image:
      "https://images.unsplash.com/photo-1602738328654-51ab2ae6c4ff?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHxwZW5jaWwlMjBza2V0Y2glMjBkcmF3aW5nJTIwaWxsdXN0cmF0aW9ufGVufDB8fHx8MTc4MjQwMjM2OHww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "Bioluminescent",
    name: "Bioluminescent",
    description: "Luminous, otherworldly, glowing, deep darks with radiant light.",
    image:
      "https://images.unsplash.com/photo-1775811071240-258c7b6c046b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxiaW9sdW1pbmVzY2VudCUyMGdsb3dpbmclMjBmb3Jlc3QlMjBhcnR8ZW58MHx8fHwxNzgyNDAyMzY3fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "Watercolor",
    name: "Watercolor",
    description: "Soft, flowing, translucent, gentle edges and blended color.",
    image:
      "https://images.unsplash.com/photo-1598495494482-172d89ff078c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHx3YXRlcmNvbG9yJTIwcGFpbnRpbmclMjBpbGx1c3RyYXRpb258ZW58MHx8fHwxNzgyNDAyMzY4fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "Storybook 3D",
    name: "Storybook 3D",
    description: "Warm, expressive, dimensional, character-forward.",
    image:
      "https://images.unsplash.com/photo-1760801656960-e5ca8e1934c6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxzdG9yeWJvb2slMjAzZCUyMGlsbHVzdHJhdGlvbnxlbnwwfHx8fDE3ODI0MDIzNjd8MA&ixlib=rb-4.1.0&q=85",
  },
];
